import { user } from "@/code/user";

export function track(
    data: { user_id: string; target: string },
    callback?: () => void,
) {
    let device = window.innerWidth > 800 ? "desktop" : "mobile";
    let info =
        "uid=" +
        data.user_id +
        "&target=" +
        data.target +
        "&device=" +
        device +
        "&ts=" +
        Date.now();
    // gtag가 로드되어 있는지 확인 후 호출
    if (typeof window.gtag !== "undefined") {
        window.gtag("event", "click", {
            event_label: info,
            event_callback: () => {
                if (callback) {
                    callback();
                }
            },
        });
    } else {
        // gtag가 없는 경우 바로 콜백 실행
        if (callback) {
            callback();
        }
    }
};

let trackAutoBind = (getUserId) => {
    const attachListener = () => {
        document.addEventListener(
            "click",
            (e) => {
                const target = e.target as Element | null;
                const el = target?.closest("[data-track]") as HTMLElement | null;
                if (!el?.dataset.track) return;
                if (el.dataset.track.includes("googleLogin")) return;

                track({
                    user_id: getUserId(),
                    target: el.dataset.track,
                });
            },
            true,
        );
    };

    // gtag가 있으면 바로, 없으면 대기
    if (typeof window.gtag !== "undefined") {
        attachListener();
    } else {
        // gtag.js 로드 완료 대기 (polling or DOM-ready 보장)
        const checkGtag = () => {
            if (typeof window.gtag !== "undefined") {
                attachListener();
            } else {
                setTimeout(checkGtag, 100); // 100ms마다 확인
            }
        };
        checkGtag();
    }
};

// gtag 클릭 이벤트 추적
trackAutoBind(() => user?.user_id || "guest");